import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import DyncAuction from 'dync-auction';
import DyncPopovers from 'dync-popovers';
import DyncProperties from 'dync-properties';
import DyncRegister from 'dync-register';
import DyncAuth from 'dync-auth';
import DyncUsers from 'dync-users';
import Loading from '@dynapp/wc-api-loading';

Vue.use(Loading, {store});
Vue.use(DyncProperties, {store});
Vue.use(DyncPopovers, {vuetify});
Vue.use(DyncRegister, {store});
Vue.use(DyncAuction, {store, router, public: true});
Vue.use(DyncUsers, {store, router});
Vue.use(DyncAuth, {store, router});

Vue.config.productionTip = false

window.vm = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
